export default "__VITE_ASSET__Di6W_wek__"